import {AfterViewInit,Directive,ElementRef,HostListener} from '@angular/core';

@Directive({
    selector: '[textAreaAutoReSize]'
})
export class TextAreaAutoReSizeDirective implements AfterViewInit {
    private row = 1;
    constructor(private el: ElementRef) {
        this.row = el.nativeElement.rows;
    }
    ngAfterViewInit(): void {
        const elem = this.el.nativeElement;
        elem.style.minHeight = "80px";
    }

    @HostListener('input', ['$event.target'])
    onInput(elem: any) {
        // elem.style.overflow = 'hidden';
        elem.style.height = 0;
        elem.style.height = (elem.scrollHeight) + "px";
    }

}
